// src/services/cateringInvoiceService.js
import apiService from "./apiService"; // Axios wrapper

const BASE_URL = "/catering-invoices";

// 🔹 Create a new invoice
export const createInvoice = async (invoiceData) => {
  try {
    const response = await apiService.post(`${BASE_URL}/create`, invoiceData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to create invoice" };
  }
};

// 🔹 Get a single invoice by ID
export const getInvoiceById = async (id) => {
  try {
    const response = await apiService.get(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to fetch invoice" };
  }
};

// 🔹 List all invoices
export const listInvoices = async () => {
  try {
    const response = await apiService.get(BASE_URL);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to fetch invoices" };
  }
};

// 🔹 Update paid amount for an invoice
export const updatePayment = async (id, paidAmount) => {
  try {
    const response = await apiService.put(`${BASE_URL}/payment/${id}`, {
      paidAmount,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to update payment" };
  }
};
